import React from "react";
import { BlueColor, WhiteLightColor } from "@app/styles/color-palette";
import { ExpandIconProps } from "./types";

export default React.memo(function ExpandIcon({
    color = BlueColor,
    circleColor = WhiteLightColor,
    expanded = true
}: ExpandIconProps) {
    const style = {
        transform: expanded ? "rotate(0deg)" : "rotate(180deg)",
        transition: "transform 0.3s ease-in-out"
    };
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <circle cx="12" cy="12" r="12" fill={circleColor} />
            <path
                d="M6.90944 14.2219C6.59702 13.9095 6.59702 13.403 6.90944 13.0906L11.4349 8.56508C11.7473 8.25266 12.2539 8.25266 12.5663 8.56508L17.0918 13.0906C17.4042 13.403 17.4042 13.9095 17.0918 14.2219C16.7794 14.5344 16.2728 14.5344 15.9604 14.2219L12.0006 10.2621L8.04081 14.2219C7.72839 14.5344 7.22185 14.5344 6.90944 14.2219Z"
                fill={color}
            />
        </svg>
    );
});